const Button = document.getElementById('popUpButton');
const overLaySheet = document.getElementById('popUpSheet');
const ButtonClose = document.getElementById('popUpButtonClose');

Button.addEventListener('click', () => {
  Button.disabled = true;

  gsap.to(overLaySheet, {
    y: 0,
    duration: 0.5,
    ease: "power3.out"
  });
});

ButtonClose.addEventListener('click', () => {
  Button.disabled = false;

  gsap.to(overLaySheet, {
    y: "100%",
    duration: 0.5,
    ease: "power3.inOut"
  });
});